import styled from "@emotion/styled"
import { useRef } from "react"
import DynamicTitleRichText from "../Common/DynamicTitleRichText"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 64px;
    display: grid;
    grid-template-columns: 1fr;
  }
`

type Props = {
  data: any
  isDriversPage?: boolean
}

const FormComponent = ({ data, isDriversPage }: Props) => {
  const formRef = useRef<HTMLDivElement>(null)

  const scrollToForm = () => {
    if (formRef.current) {
      const offset = 100
      const y =
        formRef.current.getBoundingClientRect().top +
        window.pageYOffset -
        offset
      window.scrollTo({ top: y, behavior: "smooth" })
    }
  }

  return (
    <StyledWrapper>
      <DynamicTitleRichText data={data} scrollToForm={scrollToForm} />
    </StyledWrapper>
  )
}

export default FormComponent
